import React, { useContext, useState } from 'react'
import BigModal from '../../../../../components/Modals/BigModal'
import AnDatePicker from '../../../../../components/DateTime/DatePicker'
import {
  Button,
  FormControlLabel,
  Grid,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material'
import AnDateField from '../../../../../components/DateTime/DateField'
import API from '../../../../../services/API'
import { UserContext } from '../../../../../App'

const AssignIDCardForm = ({ open, onClose, employeeID, setIDCards }) => {
  const [issueDate, setIssueDate] = useState(null)
  const [expiryDate, setExpiryDate] = useState(null)
  const [noExpiry, setNoExpiry] = useState(false)
  const [reference, setReference] = useState('')
  const { user } = useContext(UserContext)
  const handleSubmit = () => {
    API.post('/employees-assign-idcard', {
      issueDate,
      expiry: expiryDate,
      noExpiry,
      assignedTo: employeeID,
      reference,
    }).then((res) => {
      if (res.status === 200) {
        onClose()
        setIDCards((prev) => [
          ...prev,
          {
            issueDate,
            expiry: expiryDate,
            noExpiry,
            issuedBy: user,
            reference: reference,
          },
        ])
      }
    })
  }
  return (
    <BigModal open={open} onClose={onClose}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="title2">Assign ID Card</Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <AnDatePicker
            date={issueDate}
            onChange={(newDate) => setIssueDate(newDate)}
            label="Issue Date"
            disableFuture
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={8}>
          <Stack direction={{ xs: 'column', lg: 'row' }} spacing={1}>
            <AnDatePicker
              date={expiryDate}
              onChange={(newDate) => setExpiryDate(newDate)}
              label="Expiry Date"
              disabled={noExpiry}
              fullWidth
            />
            <FormControlLabel
              label="No Expiry Date"
              control={
                <Switch
                  checked={noExpiry}
                  onChange={(e) => setNoExpiry(e.target.checked)}
                  color="anBlue"
                />
              }
              sx={{
                whiteSpace: 'nowrap',
                '& .MuiFormControlLabel-label': {
                  whiteSpace: 'nowrap',
                },
              }}
            />
          </Stack>
        </Grid>
        <Grid item xs={12} lg={12}>
          <TextField
            fullWidth
            label="Reference/ID (optional)"
            value={reference}
            onChange={(e) => setReference(e.target.value)}
            autoComplete="off"
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            onClick={handleSubmit}
            disabled={!issueDate || (!expiryDate && !noExpiry)}
            fullWidth
            color="success"
            variant="contained"
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </BigModal>
  )
}

export default AssignIDCardForm
